import { AbstractModel, JsonObject, JsonProperty, DateConverter } from 'projects/core/src/public-api';
import { Project } from '../../project-misc/data/project/project';

@JsonObject('model.notification.alert.Alert')
export class ProjectAlert extends AbstractModel {

    @JsonProperty(Number, 'id')
    id: number;

    @JsonProperty(DateConverter, 'createdTime')
    createdTime?: Date;

    @JsonProperty(DateConverter, 'resolvedTime')
    resolvedTime?: Date;

    @JsonProperty(String, 'message')
    message?: string;

    @JsonProperty(Project, 'project')
    project?: Project;

    @JsonProperty(Number, 'projectId')
    projectId?: number;
}
